import React from 'react';
import PropTypes from 'prop-types';
import { Selector, SelectorWrapper } from './OptionSelector.css';
import { genRandomStr } from '../../helpers/helpers';

const OptionSelector = props => {
  const {
    align,
    borderColor,
    color,
    dataCy,
    dataEncryptedName,
    disabled,
    font,
    fontSize,
    handleClick,
    onSelectorClick,
    height,
    margin,
    name,
    options,
    padding,
    pulse,
    s3BasePath,
    selectedOption,
    textAlign,
    titleText,
    uppercase,
    width,
  } = props;

  let selectorOptions = options.map(({ disabled, label, value }) => (
    <option
      disabled={disabled}
      key={`selector-option-${genRandomStr()}`}
      value={value}
      data-cy="option-sort-select"
      data-cy-option={value}
    >
      {label}
    </option>
  ));

  if (titleText) {
    const titleOption = (
      <option
        // disabled
        key="select-a-size-default"
        selected
        value=""
        data-cy="span-sort-selected"
      >
        {titleText}
      </option>
    );
    selectorOptions = [titleOption, ...selectorOptions];
  }
  return (
    <SelectorWrapper align={align} margin={margin}>
      <Selector
        data-cy={dataCy || 'span-size-selector-label'}
        borderColor={borderColor}
        color={color}
        data-encrypted-name={dataEncryptedName}
        disabled={disabled}
        font={font}
        fontSize={fontSize}
        height={height}
        name={name}
        onClick={onSelectorClick}
        onChange={handleClick}
        padding={padding}
        pulse={pulse}
        s3BasePath={s3BasePath}
        textAlign={textAlign}
        uppercase={uppercase}
        value={selectedOption}
        width={width}
      >
        {selectorOptions}
      </Selector>
    </SelectorWrapper>
  );
};

OptionSelector.propTypes = {
  align: PropTypes.string,
  borderColor: PropTypes.string,
  color: PropTypes.string,
  dataEncryptedName: PropTypes.string,
  disabled: PropTypes.bool,
  font: PropTypes.string,
  fontSize: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  onSelectorClick: PropTypes.func,
  height: PropTypes.string,
  margin: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array.isRequired,
  padding: PropTypes.string,
  pulse: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired,
  selectedOption: PropTypes.string.isRequired,
  textAlign: PropTypes.string,
  titleText: PropTypes.string,
  uppercase: PropTypes.bool,
  width: PropTypes.string,
};

export default OptionSelector;
